import { render, staticRenderFns } from "./UserTemplate.vue?vue&type=template&id=362e430b&"
import script from "./UserTemplate.vue?vue&type=script&lang=js&"
export * from "./UserTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports